var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantagesWorldPays(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7538 4C20.0911 4 20.576 4.13924 21.0649 4.4007C21.5538 4.66216 21.9374 5.04584 22.1989 5.53473C22.4604 6.02362 22.5996 6.50855 22.5996 7.84583V13H20.5996V12H4.59961V16.7182C4.59961 17.1083 4.63514 17.2808 4.70241 17.427L4.73318 17.4886C4.82033 17.6515 4.94822 17.7794 5.11119 17.8666C5.25378 17.9429 5.39536 17.9879 5.72715 17.998L5.88155 18.0002L16.5996 18V15.1609C16.5996 14.8847 16.8235 14.6609 17.0996 14.6609C17.2075 14.6609 17.3124 14.6957 17.3988 14.7603L22.3262 18.4405C22.5475 18.6057 22.5929 18.9191 22.4276 19.1403C22.3989 19.1788 22.3647 19.2129 22.3262 19.2417L17.3988 22.9219C17.1776 23.0872 16.8643 23.0418 16.699 22.8205C16.6345 22.7341 16.5996 22.6292 16.5996 22.5213V20L6.44544 20.0002C5.10816 20.0002 4.62323 19.8609 4.13434 19.5995C3.64545 19.338 3.26177 18.9543 3.00031 18.4654C2.73885 17.9765 2.59961 17.4916 2.59961 16.1543V7.84583C2.59961 6.50855 2.73885 6.02362 3.00031 5.53473C3.26177 5.04584 3.64545 4.66216 4.13434 4.4007C4.62323 4.13924 5.10816 4 6.44544 4H18.7538ZM22.5996 13V14C22.5996 14.5523 22.1519 15 21.5996 15C21.0473 15 20.5996 14.5523 20.5996 14V13H22.5996ZM19.3177 6.00011H5.88155C5.43579 6.00011 5.27415 6.04652 5.11119 6.13368C4.94822 6.22083 4.82033 6.34872 4.73318 6.51169C4.65692 6.65428 4.61185 6.79586 4.60177 7.12765L4.59961 7.28205V8H20.5996V7.28205C20.5996 6.89201 20.5641 6.7195 20.4968 6.57329L20.466 6.51169C20.3789 6.34872 20.251 6.22083 20.088 6.13368C19.9251 6.04652 19.7634 6.00011 19.3177 6.00011Z",
    fill: "url(#paint0_linear_6310_99281)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6310_99281",
    x1: 12.5996,
    y1: 4,
    x2: 12.5996,
    y2: 23.0214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesWorldPays);
export default __webpack_public_path__ + "static/media/advantages_world_pays.d517da44fd886f22f578051bd6a71905.svg";
export { ForwardRef as ReactComponent };